<template>
  <div id="app">
    <Navbar />
    <router-view />
    <Footer />
  </div>
</template>

<script>
// import bus from './bus';
import Home from './components/Home.vue'
import Navbar from './components/Navbar.vue'
import Footer from './components/Footer.vue'
import { USER_REQUEST } from './store/actions/user'
import axios from 'axios'

/* FONTAWESOME ICONS */
import fontawesome from '@fortawesome/fontawesome' //ref: https://github.com/FortAwesome/vue-fontawesome
// import brands from '@fortawesome/fontawesome-free-brands'
import faSpinner from '@fortawesome/fontawesome-free-solid/faSpinner'
import faChevronDown from '@fortawesome/fontawesome-free-solid/faChevronDown'
import faChevronUp from '@fortawesome/fontawesome-free-solid/faChevronUp'
fontawesome.library.add(faSpinner, faChevronDown, faChevronUp)

import './assets/stylesheets/main.css';
import mixins from '@/mixins/mixins'


export default {
  name: 'app',
  components: {
    Home,
    Navbar,
    Footer
  },
  data() {
    return {
      current_user: null,
      renderSwitch: false,
    }
  },
  mixins: [mixins],
  created: function () {
    if (this.$store.getters.isAuthenticated) {
      this.$store.dispatch(USER_REQUEST)
    }
    // Using Axios, you can intercept all responses, and especially the error response. Just check for all unauthorized responses (HTTP 401) and if so, dispatch a logout action
    axios.interceptors.response.use(undefined, function (err) {
      console.log(axios.interceptors);
      return new Promise(function (resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
        // if you ever get an unauthorized, logout the user
          this.$store.dispatch(AUTH_LOGOUT)
        // you can also redirect to /login if needed !
        }
        throw err;
      });
    });
  },
  /* mounted() {
      this.fetchUser();
      this.listenToEvents();
  }, */
  methods: {
    /* listenToEvents() {
      bus.$on('refreshUser', () => {
        console.log("****** event received: refreshUser ****");
        this.fetchUser();
      });
    }, */
    
  },
  metaInfo: {
    title: 'Combined Actors of Cambridge', // if no subcomponents specify a metaInfo.title, this title will be used
    titleTemplate: '%s | Combined Actors of Cambridge' // all titles will be injected into this template
  }

}
</script>

<style>
.VueCarousel-pagination {
    position: relative;
    top: -70px;
    height: 0px;
}

.header {
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.125;
  margin-bottom: 1em;
}
.subheader {
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 1.125;
  margin-bottom: 1em;
}
.header-banner {
  background-color: #8beae9;
  margin-bottom: 1em;
}
.header-banner h1 {
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.125;
  padding-top: 0.6em;
  padding-bottom: 0.6em;
}
/* .section {
} */
/* .content ul {
  list-style: none;
  margin: 0;
} */
.header-block {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.block {
  padding: 0 !important;
}
.block-with-medium-vertical-gap {
  margin: 3rem 0 !important;
}
.block-with-small-vertical-gap {
  margin: 1rem 0 !important;
}
.block-with-vsmall-vertical-gap {
  margin: 0.5rem 0 !important;
}
.block-with-small-vertical-gap-at-top {
  margin-top: 1rem !important;
}
.block-with-small-vertical-gap-at-bottom {
  margin-bottom: 1rem !important;
}
.block-title {
  text-align: center;
  margin: 0 !important;
}
.grey-block {
    background-color: #F5F6F6;
    border-top: 1px solid #E6e6e6;
    margin-bottom: 0;
    padding-bottom: 1.5rem;
}
.white-block {
    background-color: white;
    border-top: 1px solid #E6e6e6;
    margin-bottom: 0;
    padding-bottom: 1.5rem;
}
.no-image-wrap {
    overflow: hidden; /* to prevent text wrapping around img */
    padding-left: 2rem;
}
.no-image-wrap-small {
    overflow: hidden; /* to prevent text wrapping around img */
    padding-left: 1rem;
}

/* CARDS */
.match-height {
   height: 100%;
}
.match-content-height {
   height: 75%;
}

.admin.breadcrumb li a {
    color: #4a4a4a;
}
.admin.breadcrumb li.is-active a {
    color: darkgrey;
}
h1 .admin.breadcrumb {
    margin-bottom: 0.6em;
}

.large-checkbox {
    transform: scale(1.2);
}

@media screen and (min-width: 1280px) {
    .container img {
        max-width: 750px !important;
    }
}

img.bordered-image {
    border: 1px solid #ccc;
}

/* TEXT / TITLES */
.title3 {
    color: #4a4a4a;
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.25;
    margin-top: 1.5rem;
    margin-bottom: 0.8rem;
    word-break: break-word;

}

.text-small {
    font-size: 0.9rem;
}

/* BUTTONS */
.is-transparent {
  background: transparent !important;
  border: 1px solid #999 !important;
}


/* DATES / VENUES / etc */
.dateAndVenueTitle {
    font-size: 1.25rem;
    font-weight: 500;
}
.dateAndVenueDescription {
    color: rgba(0,0,0,0.6)
}


/* FEATURED */
.featuredplay-title {
    display: inline-block;
}
.featuredplay-message {
    vertical-align: 0.24em;
}
.featuredplay-blurb {
    font-size: 120%;
}

/* .formatted-text ul {
  padding-left: 20px;
  list-style: inherit;
} */
/* blockquote {
  padding: 20px !important;
} */

</style>



// WEBPACK FOOTER //
// src/App.vue